import { render, staticRenderFns } from "./DetailJournal.vue?vue&type=template&id=64c56971"
import script from "./DetailJournal.vue?vue&type=script&lang=js"
export * from "./DetailJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports